import React from 'react';
import { colors } from 'src/themes/default';
import { applicationMessageTypesColors } from '../../resources/constantsCodes/constants';

export const DashboardIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.7998 2.7998V22.2998H22.2998V2.7998H2.7998ZM20.7998 11.7998H13.2998V4.1998H20.7998V11.7998ZM4.1998 4.1998H11.6998V20.6998H4.1998V4.1998ZM13.1998 20.7998V13.2998H20.6998V20.7998H13.1998Z"
            fill={colors.icon}
        />
    </svg>
);

export const TaskIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.8002 3.2H15.5002V2.5H9.5002V3.3H4.2002V4V22.5V23.3H20.7002V22.5V4V3.2H20.8002ZM19.2002 21.8H5.8002V4.8H9.5002V5.6H15.5002V4.8H19.3002V21.8H19.2002Z"
            fill={colors.icon}
        />
        <path d="M9.60059 9.5H8.10059V11H9.60059V9.5Z" fill={colors.icon} />
        <path d="M16.9004 9.5H10.9004V11H16.9004V9.5Z" fill={colors.icon} />
        <path d="M16.9004 12.5H10.9004V14H16.9004V12.5Z" fill={colors.icon} />
        <path d="M16.9004 15.5H10.9004V17H16.9004V15.5Z" fill={colors.icon} />
        <path d="M9.60059 12.5H8.10059V14H9.60059V12.5Z" fill={colors.icon} />
        <path d="M9.60059 15.5H8.10059V17H9.60059V15.5Z" fill={colors.icon} />
    </svg>
);

export const OrderIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.1998 7.4998V6.9998L12.7998 1.7998H12.0998L1.7998 6.9998V7.4998V17.4998V17.8998L12.1998 23.1998L12.4998 23.3998L12.7998 23.1998L23.1998 17.9998V17.4998V7.4998ZM12.4998 3.2998L20.7998 7.4998L12.4998 11.6998L4.1998 7.4998L12.4998 3.2998ZM3.1998 8.6998L11.6998 12.9998V21.2998L3.1998 16.9998V8.6998ZM13.1998 21.2998V12.9998L21.6998 8.6998V16.9998L13.1998 21.2998Z"
            fill={colors.icon}
        />
    </svg>
);

export const ClaimIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.4998 2.9002C10.4998 2.9002 8.5998 3.4002 6.89981 4.4002L7.4998 1.4002L6.0998 1.2002L5.0998 6.10019L5.6998 7.0002L10.5998 8.0002L10.8998 6.5002L7.5998 5.8002C9.0998 4.9002 10.6998 4.4002 12.4998 4.4002C17.5998 4.4002 21.6998 8.5002 21.6998 13.6002C21.6998 18.7002 17.5998 22.8002 12.4998 22.8002C7.3998 22.8002 3.2998 18.7002 3.2998 13.6002H1.7998C1.7998 19.5002 6.5998 24.4002 12.5998 24.4002C18.5998 24.4002 23.3998 19.6002 23.3998 13.6002C23.3998 7.6002 18.3998 2.9002 12.4998 2.9002Z"
            fill={colors.icon}
        />
        <path
            d="M16.1998 9.90039H8.7998V17.4004H16.2998V9.90039H16.1998ZM14.7998 15.9004H10.2998V11.4004H14.7998V15.9004Z"
            fill={colors.icon}
        />
    </svg>
);

export const ReturnIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 6.0002H6.8L9.1 3.8002L8 2.7002L4.5 6.2002V7.3002L8 10.8002L9.1 9.8002L6.8 7.5002H19.2V18.0002H14V19.5002H20L20.8 18.8002V6.8002L20 6.0002Z"
            fill={colors.icon}
        />
        <path d="M4.2002 22.5H11.7002V15H4.2002V22.5ZM5.8002 16.5H10.3002V21H5.8002V16.5Z" fill={colors.icon} />
    </svg>
);

export const ReceivingIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3998 9.2V8.9L19.9998 3H19.5998H5.3998H4.9998L1.7998 8.9V9.2V22H2.5998H22.5998H23.3998V9.2ZM5.89981 4.5H19.0998L21.1998 8.5H3.7998L5.89981 4.5ZM21.7998 20.5H3.1998V10H21.6998L21.7998 20.5Z"
            fill={colors.icon}
        />
        <path
            d="M11.5994 18.2001L16.5994 13.2001L15.5994 12.1001L11.0994 16.6001L9.39941 14.9001L8.39941 16.0001L10.5994 18.2001H11.5994Z"
            fill={colors.icon}
        />
    </svg>
);

export const InventoryIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.4998 4.1L20.0998 3H19.5998H19.1998H6.0998H5.3998H4.8998L4.4998 4.1L1.7998 11.2V20.8V21.2V22H2.5998H2.9998H22.2998H22.6998H23.4998V21.2V20.8V11.2L20.4998 4.1ZM5.9998 4.5H18.9998L21.3998 10.5H16.4998L15.6998 11.3C15.6998 13.1 14.1998 14.5 12.4998 14.5C10.7998 14.5 9.2998 13 9.2998 11.3L8.4998 10.5H3.5998L5.9998 4.5ZM21.7998 20.5H3.1998V12H7.7998C8.1998 14.3 10.0998 16 12.4998 16C14.8998 16 16.7998 14.3 17.1998 12H21.7998V20.5Z"
            fill={colors.icon}
        />
    </svg>
);

export const DocumentIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.2002 21.7998H5.8002V3.1998H14.6002L16.1002 1.7998H4.2002V23.1998H20.8002V10.8998L19.2002 12.4998V21.7998Z"
            fill={colors.icon}
        />
        <path
            d="M19.3002 1.8999H18.2002L11.1002 8.9999L11.0002 9.1999L9.2002 14.4999L10.1002 15.3999L15.4002 13.5999L15.7002 13.3999L22.8002 6.2999V5.3999L19.3002 1.8999ZM12.3002 13.1999L11.6002 12.4999L12.1002 10.8999L13.9002 12.6999L12.3002 13.1999ZM15.3002 11.8999L12.8002 9.3999L18.8002 3.3999L21.3002 5.8999L15.3002 11.8999Z"
            fill={colors.icon}
        />
    </svg>
);

export const TransportIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.1998 9.5002L18.6998 8.9002L17.2998 3.8002L17.0998 3.2002H1.7998V4.0002V18.5002V19.3002H4.3998C4.6998 20.7002 5.9998 21.8002 7.5998 21.8002C9.1998 21.8002 10.3998 20.7002 10.7998 19.3002H14.4998C14.7998 20.7002 16.0998 21.8002 17.6998 21.8002C19.2998 21.8002 20.4998 20.7002 20.8998 19.3002H23.4998V18.5002V12.9002C23.1998 11.4002 22.4998 10.1002 21.1998 9.5002ZM7.4998 20.2002C6.4998 20.2002 5.6998 19.4002 5.6998 18.4002C5.6998 17.4002 6.4998 16.6002 7.4998 16.6002C8.4998 16.6002 9.2998 17.4002 9.2998 18.4002C9.2998 19.4002 8.4998 20.2002 7.4998 20.2002ZM17.4998 20.2002C16.4998 20.2002 15.6998 19.4002 15.6998 18.4002C15.6998 17.4002 16.4998 16.6002 17.4998 16.6002C18.4998 16.6002 19.2998 17.4002 19.2998 18.4002C19.2998 19.4002 18.4998 20.2002 17.4998 20.2002ZM21.7998 17.8002H20.6998C20.3998 16.4002 19.0998 15.3002 17.4998 15.3002C15.8998 15.3002 14.6998 16.4002 14.2998 17.8002H10.5998C10.2998 16.4002 8.9998 15.3002 7.39981 15.3002C5.79981 15.3002 4.5998 16.4002 4.1998 17.8002H3.1998V4.8002H16.0998L17.3998 9.8002L17.4998 10.1002L20.5998 10.9002C21.2998 11.2002 21.6998 12.1002 21.6998 12.9002L21.7998 17.8002Z"
            fill={colors.icon}
        />
    </svg>
);

export const SettingsIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.2002 23.2002H11.8002C10.7002 23.2002 9.7002 22.3002 9.7002 21.1002C9.7002 20.9002 9.60019 20.7002 9.4002 20.6002C9.2002 20.5002 9.0002 20.5002 8.9002 20.4002C8.7002 20.3002 8.5002 20.4002 8.3002 20.5002C7.5002 21.3002 6.2002 21.3002 5.4002 20.5002L4.4002 19.5002C3.6002 18.7002 3.6002 17.4002 4.4002 16.6002C4.6002 16.4002 4.6002 16.2002 4.5002 16.0002C4.4002 15.8002 4.3002 15.6002 4.3002 15.5002C4.2002 15.3002 4.0002 15.2002 3.8002 15.2002C2.7002 15.2002 1.7002 14.3002 1.7002 13.1002V11.7002C1.7002 10.6002 2.6002 9.6002 3.8002 9.6002C4.0002 9.6002 4.2002 9.5002 4.3002 9.3002C4.4002 9.1002 4.4002 8.9002 4.5002 8.8002C4.6002 8.6002 4.5002 8.4002 4.4002 8.2002C3.6002 7.4002 3.6002 6.1002 4.4002 5.3002L5.4002 4.3002C6.2002 3.5002 7.5002 3.5002 8.3002 4.3002C8.5002 4.5002 8.7002 4.5002 8.9002 4.4002C9.10019 4.3002 9.3002 4.2002 9.4002 4.2002C9.60019 4.2002 9.8002 4.0002 9.8002 3.8002C9.8002 2.7002 10.7002 1.7002 11.9002 1.7002H13.3002C14.4002 1.7002 15.4002 2.6002 15.4002 3.8002C15.4002 4.0002 15.5002 4.2002 15.7002 4.3002C15.9002 4.4002 16.1002 4.4002 16.2002 4.5002C16.4002 4.6002 16.6002 4.5002 16.8002 4.4002C17.6002 3.6002 18.9002 3.6002 19.7002 4.4002L20.7002 5.4002C21.5002 6.2002 21.5002 7.5002 20.7002 8.3002C20.5002 8.5002 20.5002 8.7002 20.6002 8.9002C20.7002 9.10019 20.8002 9.3002 20.8002 9.4002C20.9002 9.60019 21.1002 9.7002 21.3002 9.7002C22.4002 9.7002 23.4002 10.6002 23.4002 11.8002V13.2002C23.4002 14.3002 22.5002 15.3002 21.3002 15.3002C21.1002 15.3002 20.9002 15.4002 20.8002 15.6002C20.7002 15.8002 20.7002 16.0002 20.6002 16.1002C20.5002 16.3002 20.6002 16.5002 20.7002 16.7002C21.5002 17.5002 21.5002 18.8002 20.7002 19.6002L19.7002 20.6002C18.9002 21.4002 17.6002 21.4002 16.8002 20.6002C16.6002 20.4002 16.4002 20.4002 16.2002 20.5002C16.0002 20.6002 15.8002 20.7002 15.7002 20.7002C15.5002 20.8002 15.4002 21.0002 15.4002 21.2002C15.2002 22.3002 14.3002 23.2002 13.2002 23.2002ZM8.7002 18.9002C9.0002 18.9002 9.3002 19.0002 9.5002 19.1002C9.6002 19.2002 9.80019 19.2002 9.9002 19.3002C10.7002 19.6002 11.2002 20.4002 11.2002 21.2002C11.2002 21.5002 11.5002 21.8002 11.8002 21.8002H13.2002C13.5002 21.8002 13.8002 21.5002 13.8002 21.2002C13.8002 20.3002 14.3002 19.6002 15.1002 19.3002C15.3002 19.2002 15.4002 19.2002 15.5002 19.1002C16.3002 18.8002 17.2002 18.9002 17.8002 19.5002C18.0002 19.7002 18.4002 19.7002 18.6002 19.5002L19.6002 18.5002C19.8002 18.3002 19.8002 17.9002 19.6002 17.7002C19.0002 17.1002 18.8002 16.2002 19.2002 15.4002C19.3002 15.3002 19.3002 15.1002 19.4002 15.0002C19.7002 14.2002 20.5002 13.7002 21.3002 13.7002C21.6002 13.7002 21.9002 13.4002 21.9002 13.1002V11.7002C21.9002 11.4002 21.6002 11.1002 21.3002 11.1002C20.4002 11.1002 19.7002 10.6002 19.4002 9.8002C19.3002 9.6002 19.3002 9.5002 19.2002 9.4002C18.9002 8.60019 19.0002 7.70019 19.6002 7.10019C19.8002 6.9002 19.8002 6.5002 19.6002 6.3002L18.6002 5.3002C18.4002 5.1002 18.0002 5.1002 17.8002 5.3002C17.2002 5.9002 16.3002 6.10019 15.5002 5.7002C15.4002 5.6002 15.2002 5.6002 15.1002 5.5002C14.3002 5.2002 13.8002 4.4002 13.8002 3.6002C13.8002 3.3002 13.5002 3.0002 13.2002 3.0002H11.8002C11.5002 3.0002 11.2002 3.3002 11.2002 3.6002C11.2002 4.5002 10.7002 5.2002 9.9002 5.5002C9.80019 5.8002 9.7002 5.8002 9.5002 5.9002C8.8002 6.2002 7.8002 6.1002 7.2002 5.5002C7.0002 5.3002 6.7002 5.3002 6.4002 5.5002L5.4002 6.5002C5.3002 6.7002 5.3002 7.0002 5.5002 7.2002C6.1002 7.8002 6.3002 8.7002 5.9002 9.5002C5.8002 9.7002 5.8002 9.8002 5.7002 10.0002C5.4002 10.8002 4.6002 11.3002 3.8002 11.3002C3.5002 11.3002 3.2002 11.6002 3.2002 11.9002V13.3002C3.2002 13.6002 3.5002 13.9002 3.8002 13.9002C4.7002 13.9002 5.4002 14.4002 5.7002 15.2002C5.8002 15.4002 5.8002 15.5002 5.9002 15.6002C6.2002 16.4002 6.1002 17.3002 5.5002 17.9002C5.3002 18.1002 5.3002 18.5002 5.5002 18.7002L6.5002 19.7002C6.7002 19.9002 7.1002 19.9002 7.3002 19.7002C7.6002 19.1002 8.2002 18.9002 8.7002 18.9002Z"
            fill={colors.icon}
        />
        <path
            d="M12.4998 16.8004C10.1998 16.8004 8.2998 14.9004 8.2998 12.6004C8.2998 10.3004 10.1998 8.40039 12.4998 8.40039C14.7998 8.40039 16.6998 10.3004 16.6998 12.6004C16.6998 14.9004 14.7998 16.8004 12.4998 16.8004ZM12.4998 9.80039C10.9998 9.80039 9.6998 11.0004 9.6998 12.6004C9.6998 14.2004 10.8998 15.4004 12.4998 15.4004C14.0998 15.4004 15.2998 14.2004 15.2998 12.6004C15.2998 11.0004 13.9998 9.80039 12.4998 9.80039Z"
            fill={colors.icon}
        />
    </svg>
);

export const ActionDotsIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7002 11.2002H11.2002V13.7002H13.7002V11.2002Z" fill={colors.icon} />
        <path d="M18.7002 11.2002H16.2002V13.7002H18.7002V11.2002Z" fill={colors.icon} />
        <path d="M8.7002 11.2002H6.2002V13.7002H8.7002V11.2002Z" fill={colors.icon} />
    </svg>
);

export const WarningIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.2004 2.2002H11.9004L1.90039 22.2002L2.60039 23.3002H22.6004L23.3004 22.2002L13.2004 2.2002ZM3.70039 21.8002L12.5004 4.2002L21.3004 21.8002H3.70039Z"
            fill={colors.icon}
        />
        <path d="M13.3008 9.40039H11.8008V16.4004H13.3008V9.40039Z" fill={colors.icon} />
        <path d="M13.4006 18.1001H11.6006V19.9001H13.4006V18.1001Z" fill={colors.icon} />
    </svg>
);

export const CautionIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.2002 11.6003C18.2002 8.40029 15.6002 5.80029 12.4002 5.80029C9.2002 5.80029 6.6002 8.40029 6.6002 11.6003V15.8003H4.2002V22.8003H20.7002V15.8003H18.2002V11.6003ZM8.2002 11.6003C8.2002 9.30029 10.1002 7.40029 12.4002 7.40029C14.7002 7.40029 16.6002 9.30029 16.6002 11.6003V15.8003H8.2002V11.6003ZM19.2002 17.4003V21.4003H5.8002V17.4003H6.8002H18.3002H19.2002Z"
            fill={colors.icon}
        />
        <path
            d="M9.5 12.0999H11C11 11.0999 11.7 10.1999 12.7 9.8999L12.3 8.3999C10.7 8.8999 9.5 10.3999 9.5 12.0999Z"
            fill={colors.icon}
        />
        <path d="M13.2998 2.1001H11.7998V4.6001H13.2998V2.1001Z" fill={colors.icon} />
        <path d="M22.5 11.3999H20V12.8999H22.5V11.3999Z" fill={colors.icon} />
        <path d="M5 11.3999H2.5V12.8999H5V11.3999Z" fill={colors.icon} />
        <path
            d="M19.5226 4.09993L17.7549 5.86768L18.8155 6.92833L20.5833 5.16058L19.5226 4.09993Z"
            fill={colors.icon}
        />
        <path d="M5.53526 4.14785L4.47461 5.2085L6.24236 6.97625L7.30301 5.9156L5.53526 4.14785Z" fill={colors.icon} />
    </svg>
);

export const CloseIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 1.5C6.4 1.5 1.5 6.4 1.5 12.5C1.5 18.6 6.4 23.5 12.5 23.5C18.6 23.5 23.5 18.6 23.5 12.5C23.5 6.4 18.6 1.5 12.5 1.5ZM12.5 22C7.3 22 3 17.7 3 12.5C3 7.3 7.3 3 12.5 3C17.7 3 22 7.3 22 12.5C22 17.7 17.7 22 12.5 22Z"
            fill={colors.icon}
        />
        <path
            d="M15.4999 8.3999L12.4999 11.3999L9.4999 8.3999L8.3999 9.4999L11.3999 12.4999L8.3999 15.4999L9.4999 16.5999L12.4999 13.5999L15.4999 16.5999L16.5999 15.4999L13.5999 12.4999L16.5999 9.4999L15.4999 8.3999Z"
            fill={colors.icon}
        />
    </svg>
);

export const LockIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.1998 9.8002V6.5002C17.1998 3.9002 15.0998 1.7002 12.3998 1.7002C9.6998 1.7002 7.7998 3.9002 7.7998 6.5002V9.7002H4.7998V23.2002H20.2998V9.8002H17.1998ZM9.1998 6.5002C9.1998 4.7002 10.6998 3.3002 12.3998 3.3002C14.0998 3.3002 15.5998 4.8002 15.5998 6.5002V9.7002H9.1998V6.5002ZM18.7998 21.8002H6.1998V11.2002H7.6998H17.1998H18.6998V21.8002H18.7998Z"
            fill={colors.icon}
        />
        <path
            d="M12.5 18.5C13.6046 18.5 14.5 17.6046 14.5 16.5C14.5 15.3954 13.6046 14.5 12.5 14.5C11.3954 14.5 10.5 15.3954 10.5 16.5C10.5 17.6046 11.3954 18.5 12.5 18.5Z"
            fill={colors.icon}
        />
    </svg>
);

export const DeleteIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.1996 5.8002V4.2002C16.1996 2.8002 15.0996 1.7002 13.6996 1.7002H11.1996C9.79961 1.7002 8.69961 2.8002 8.69961 4.2002V5.7002H3.59961L6.19961 23.2002H18.6996L21.2996 5.7002H16.1996V5.8002ZM10.1996 4.2002C10.1996 3.6002 10.5996 3.2002 11.1996 3.2002H13.6996C14.1996 3.2002 14.6996 3.6002 14.6996 4.2002V5.7002H10.1996V4.2002ZM17.4996 21.8002H7.49961L5.39961 7.2002H9.49961H15.4996H19.5996L17.4996 21.8002Z"
            fill={colors.icon}
        />
        <path d="M15.0996 9.2002H13.5996V19.6002H15.0996V9.2002Z" fill={colors.icon} />
        <path d="M11.3994 9.2002H9.89941V19.6002H11.3994V9.2002Z" fill={colors.icon} />
    </svg>
);

export const ShowIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 15C13.8807 15 15 13.8807 15 12.5C15 11.1193 13.8807 10 12.5 10C11.1193 10 10 11.1193 10 12.5C10 13.8807 11.1193 15 12.5 15Z"
            fill={colors.icon}
        />
        <path
            d="M15 6.10014C13.6 5.80014 12.5 5.80014 11.5 5.90014C4.5 6.50014 1.5 12.5001 1.5 12.5001C1.5 12.5001 4.7 19.1001 12.5 19.1001C20.3 19.1001 23.5 12.5001 23.5 12.5001C23.5 12.5001 21 7.40014 15 6.10014ZM7 16.1001C5 15.0001 3.8 13.4001 3.2 12.5001C3.8 11.6001 5 10.1001 7 8.90014C6.3 9.90014 5.9 11.2001 5.9 12.5001C5.9 13.8001 6.3 15.1001 7 16.1001ZM12.5 17.6001C9.7 17.6001 7.4 15.3001 7.4 12.5001C7.4 9.80014 9.6 7.50014 12.3 7.40014C12.4 7.40014 12.4 7.40014 12.5 7.40014C12.6 7.40014 12.6 7.40014 12.7 7.40014C15.4 7.50014 17.6 9.80014 17.6 12.5001C17.6 15.3001 15.3 17.6001 12.5 17.6001ZM18 16.1001C18.7 15.1001 19.1 13.8001 19.1 12.5001C19.1 11.2001 18.7 9.90014 18 8.90014C20 10.1001 21.2 11.6001 21.7 12.5001C21.2 13.4001 20 14.9001 18 16.1001Z"
            fill={colors.icon}
        />
    </svg>
);
export const HideIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.1996 20.2L5.39961 4.3L3.99961 3L2.99961 4L6.49961 7.5C3.09961 9.5 1.59961 12.5 1.59961 12.5C1.59961 12.5 4.79961 19.1 12.5996 19.1C14.3996 19.1 15.8996 18.7 17.2996 18.2L20.9996 22L21.9996 21L21.1996 20.2ZM3.19961 12.5C3.79961 11.6 4.99961 10 7.09961 8.8C6.39961 9.9 5.99961 11.1 5.99961 12.5C5.99961 13.9 6.39961 15.1 7.09961 16.2C5.09961 15 3.79961 13.4 3.19961 12.5ZM12.5996 17.6C9.79961 17.6 7.49961 15.3 7.49961 12.5C7.49961 11.4 7.89961 10.4 8.49961 9.5L9.99961 11C9.79961 11.4 9.59961 11.9 9.59961 12.4C9.59961 14 10.8996 15.3 12.4996 15.3C12.9996 15.3 13.4996 15.2 13.8996 14.9L15.3996 16.4C14.6996 17.2 13.6996 17.6 12.5996 17.6Z"
            fill={colors.icon}
        />
        <path
            d="M13.0992 5.8998C11.3992 5.7998 10.1992 6.0998 10.1992 6.0998L11.5992 7.4998C11.8992 7.3998 12.0992 7.3998 12.3992 7.3998H12.4992C12.5992 7.3998 12.6992 7.3998 12.7992 7.3998C15.4992 7.4998 17.5992 9.7998 17.5992 12.4998C17.5992 12.7998 17.5992 13.1998 17.4992 13.4998L18.6992 14.6998C18.8992 13.9998 19.0992 13.2998 19.0992 12.4998C19.0992 11.1998 18.6992 9.9998 18.0992 8.9998C19.9992 10.1998 21.1992 11.6998 21.6992 12.5998C21.2992 13.2998 20.4992 14.2998 19.1992 15.2998L20.2992 16.3998C22.4992 14.5998 23.3992 12.5998 23.3992 12.5998C23.3992 12.5998 20.3992 6.0998 13.0992 5.8998Z"
            fill={colors.icon}
        />
    </svg>
);

export const ImportIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.8 5.6002V17.8002H13.2V5.6002L16 8.3002L17 7.2002L13 3.2002H12L8 7.2002L9 8.3002L11.8 5.6002Z"
            fill={colors.icon}
        />
        <path
            d="M16.7004 10.5V12H20.6004V20.5H4.40039V12H8.30039V10.5H2.90039V22H22.1004V10.5H16.7004Z"
            fill={colors.icon}
        />
    </svg>
);

export const EditIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.3004 3L14.8004 3.5L6.30039 12L6.20039 12.2V12.3L3.40039 20.8L4.30039 21.7L12.8004 18.9L13.0004 18.8L13.1004 18.7L21.6004 10.2L22.1004 9.7L15.3004 3ZM7.70039 19L6.00039 17.3L7.10039 13.9L11.0004 17.8L7.70039 19ZM12.5004 17.1L7.90039 12.5L15.3004 5.1L19.9004 9.7L12.5004 17.1Z"
            fill={colors.icon}
        />
    </svg>
);

export const ExportIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 14.2998L12 18.2998H13L17 14.2998L16 13.1998L13.2 15.8998V3.7998H11.8V15.8998L9 13.1998L8 14.2998Z"
            fill={colors.icon}
        />
        <path
            d="M16.8004 10.5V12H20.6004V20.5H4.40039V12H8.30039V10.5H2.90039V22H22.1004V10.5H16.8004Z"
            fill={colors.icon}
        />
    </svg>
);

export const BuildingIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.8998 3.2002H11.9998L4.2998 8.9002V9.3002V21.3002V22.0002H9.9998H14.9998H20.7998V21.2002V9.2002V9.0002L12.8998 3.2002ZM14.1998 20.5002H10.7998V14.1002H14.1998V20.5002ZM19.2998 20.5002H15.6998V13.4002V12.6002H9.2998V13.4002V13.6002V20.5002H5.7998V9.6002L12.5998 4.6002L19.2998 9.6002V20.5002Z"
            fill={colors.icon}
        />
    </svg>
);
export const DuplicateIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.39941 2.1001V5.4001H10.8994V3.6001H21.3994V14.1001H19.5994V15.6001H22.8994V2.1001H9.39941Z"
            fill={colors.icon}
        />
        <path
            d="M3.89941 15.4001H5.39941V8.6001H16.3994V19.6001H9.59941V21.1001H17.8994V7.1001H3.89941V15.4001Z"
            fill={colors.icon}
        />
        <path
            d="M5.39961 17.8999H3.89961V19.5999H2.09961V21.0999H3.89961V22.8999H5.39961V21.0999H7.09961V19.5999H5.39961V17.8999Z"
            fill={colors.icon}
        />
    </svg>
);
export const PrintIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.4998 7.7998H17.2998V2.8998V2.4998V1.7998H16.4998H8.4998H7.6998V2.8998V7.7998H3.4998H2.7998V8.5998V8.9998V19.9998V20.7998H7.7998V23.2998H8.5998H16.5998H17.3998V20.7998H22.3998V19.9998V8.8998V8.4998V7.7998H21.4998ZM15.7998 21.7998H9.1998V13.2998H15.6998V21.7998H15.7998ZM20.7998 19.1998H17.2998V13.1998H18.9998V11.6998H16.4998H8.4998H5.9998V13.1998H7.7998V19.1998H4.1998V9.1998H8.3998H16.3998H20.5998V19.1998H20.7998ZM9.1998 3.1998H15.6998V7.6998H9.1998V3.1998Z"
            fill={colors.icon}
        />
    </svg>
);
export const ShippingLabelIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.1998 12.2002L20.4998 4.2002H19.9998H1.7998V5.0002V20.0002V20.8002H19.9998H20.5998L23.1998 12.8002V12.2002ZM19.4998 19.2002H3.1998V5.8002H19.3998L21.5998 12.5002L19.4998 19.2002Z"
            fill={colors.icon}
        />
        <path d="M16.7998 8.80029H5.7998V10.3003H16.7998V8.80029Z" fill={colors.icon} />
        <path d="M16.7998 11.8003H5.7998V13.3003H16.7998V11.8003Z" fill={colors.icon} />
        <path d="M16.6994 14.8003H8.89941V16.3003H16.6994V14.8003Z" fill={colors.icon} />
        <path d="M7.5998 14.6001H5.7998V16.4001H7.5998V14.6001Z" fill={colors.icon} />
    </svg>
);

export const TrashIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.1996 5.8002V4.2002C16.1996 2.8002 15.0996 1.7002 13.6996 1.7002H11.1996C9.79961 1.7002 8.69961 2.8002 8.69961 4.2002V5.7002H3.59961L6.19961 23.2002H18.6996L21.2996 5.7002H16.1996V5.8002ZM10.1996 4.2002C10.1996 3.6002 10.5996 3.2002 11.1996 3.2002H13.6996C14.1996 3.2002 14.6996 3.6002 14.6996 4.2002V5.7002H10.1996V4.2002ZM17.4996 21.8002H7.49961L5.39961 7.2002H9.49961H15.4996H19.5996L17.4996 21.8002Z"
            fill={colors.icon}
        />
        <path d="M15.0996 9.2002H13.5996V19.6002H15.0996V9.2002Z" fill={colors.icon} />
        <path d="M11.3994 9.2002H9.89941V19.6002H11.3994V9.2002Z" fill={colors.icon} />
    </svg>
);

export const EyeIcon = () => (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_15332_27289)">
            <path
                d="M10.9004 2.74219C14.5004 2.74219 17.7004 4.64219 19.5004 7.74219C19.7004 8.04219 19.7004 8.44219 19.5004 8.74219C17.8004 11.8422 14.5004 13.7422 10.9004 13.7422C7.30039 13.7422 4.10039 11.8422 2.30039 8.74219C2.10039 8.44219 2.10039 8.04219 2.30039 7.74219C4.10039 4.64219 7.30039 2.74219 10.9004 2.74219ZM10.9004 0.742188C6.10039 0.742188 1.90039 3.64219 0.100391 7.84219C0.000390626 8.14219 0.000390626 8.34219 0.100391 8.64219C1.90039 12.8422 6.10039 15.7422 10.9004 15.7422C15.7004 15.7422 19.9004 12.8422 21.7004 8.64219C21.8004 8.34219 21.8004 8.04219 21.7004 7.84219C19.9004 3.64219 15.8004 0.742188 10.9004 0.742188ZM10.3004 5.84219C12.2004 5.44219 13.8004 7.04219 13.3004 8.84219C13.1004 9.74219 12.4004 10.4422 11.5004 10.6422C9.60039 11.0422 8.00039 9.44219 8.50039 7.64219C8.70039 6.74219 9.40039 6.04219 10.3004 5.84219ZM12.1004 3.94219C8.70039 3.04219 5.70039 6.04219 6.60039 9.44219C7.00039 10.9422 8.20039 12.1422 9.70039 12.5422C13.1004 13.4422 16.2004 10.4422 15.3004 6.94219C14.9004 5.54219 13.6004 4.34219 12.1004 3.94219Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_15332_27289">
                <rect width="21.8" height="15" fill="white" transform="translate(0 0.742188)" />
            </clipPath>
        </defs>
    </svg>
);

export const FileCountryIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13633_115509)">
            <path
                d="M18 13V20H4V6H9.02C9.07 5.29 9.24 4.62 9.5 4H2V22H20V15L18 13ZM16.5 18H5.5L8.25 14.47L10.21 16.83L12.96 13.29L16.5 18ZM19.3 8.89C19.74 8.19 20 7.38 20 6.5C20 4.01 17.99 2 15.5 2C13.01 2 11 4.01 11 6.5C11 8.99 13.01 11 15.49 11C16.37 11 17.19 10.74 17.88 10.3L21 13.42L22.42 12L19.3 8.89ZM15.5 9C14.12 9 13 7.88 13 6.5C13 5.12 14.12 4 15.5 4C16.88 4 18 5.12 18 6.5C18 7.88 16.88 9 15.5 9Z"
                fill={colors.icon}
            />
        </g>
        <defs>
            <clipPath id="clip0_13633_115509">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FileCountryReturnIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13633_115509)">
            <path
                d="M18 13V20H4V6H9.02C9.07 5.29 9.24 4.62 9.5 4H2V22H20V15L18 13ZM19.3 8.89C19.74 8.19 20 7.38 20 6.5C20 4.01 17.99 2 15.5 2C13.01 2 11 4.01 11 6.5C11 8.99 13.01 11 15.49 11C16.37 11 17.19 10.74 17.88 10.3L21 13.42L22.42 12L19.3 8.89ZM15.5 9C14.12 9 13 7.88 13 6.5C13 5.12 14.12 4 15.5 4C16.88 4 18 5.12 18 6.5C18 7.88 16.88 9 15.5 9Z"
                fill={colors.icon}
            />
            <path
                d="M14 10.0001H7.4L8.55 8.9001L8 8.3501L6.25 10.1001V10.6501L8 12.4001L8.55 11.9001L7.4 10.7501H13.6V16.0001H11V16.7501H14L14.4 16.4001V10.4001L14 10.0001Z"
                fill={colors.icon}
            />
        </g>
        <defs>
            <clipPath id="clip0_13633_115509">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DolarIcon = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.2 10.7999L12.1 7.6999C12.3 7.6999 12.4 7.7999 12.6 7.8999C12.8 7.9999 12.9 8.0999 13 8.1999C13.1 8.2999 13.2 8.4999 13.3 8.6999C13.4 8.8999 13.4 9.0999 13.5 9.2999V9.3999L14.8 9.1999V9.0999C14.8 8.7999 14.7 8.5999 14.6 8.2999C14.5 7.9999 14.3 7.7999 14.1 7.4999C13.9 7.2999 13.6 7.0999 13.3 6.8999C13 6.6999 12.6 6.5999 12.1 6.5999V5.3999H11V6.4999C10.6 6.4999 10.3 6.5999 9.9 6.7999C9.5 6.8999 9.2 7.0999 9 7.2999C8.8 7.4999 8.6 7.7999 8.5 8.0999C8.4 8.3999 8.3 8.6999 8.3 9.0999C8.3 9.4999 8.4 9.8999 8.5 10.1999C8.6 10.4999 8.8 10.7999 9 10.9999C9.2 11.1999 9.5 11.3999 9.8 11.4999C10.1 11.5999 10.5 11.6999 10.9 11.7999V14.9999C9.9 14.8999 9.4 14.2999 9.3 13.3999V13.2999H8V13.3999C8.1 14.2999 8.4 14.8999 8.9 15.3999C9.4 15.8999 10.1 16.0999 11 16.1999V17.4999H12.1V16.1999C12.5 16.1999 12.9 16.0999 13.3 15.8999C13.7 15.6999 14 15.4999 14.2 15.2999C14.4 14.9999 14.6 14.7999 14.8 14.3999C14.9 14.0999 15 13.6999 15 13.3999C15 12.4999 14.8 11.8999 14.3 11.3999C13.8 11.1999 13.1 10.8999 12.2 10.7999ZM13.5 13.5999C13.5 13.9999 13.4 14.3999 13.1 14.6999C12.9 14.9999 12.5 15.0999 12.1 15.1999V12.1999C12.4 12.2999 12.6 12.2999 12.8 12.3999C13 12.4999 13.1 12.5999 13.2 12.6999C13.3 12.7999 13.4 12.9999 13.4 13.0999C13.5 13.2999 13.5 13.3999 13.5 13.5999ZM11 7.6999V10.5999C10.8 10.4999 10.6 10.4999 10.4 10.3999C10.2 10.2999 10.1 10.1999 9.9 10.0999C9.8 9.9999 9.7 9.7999 9.7 9.6999C9.7 9.4999 9.6 9.3999 9.6 9.1999C9.6 8.8999 9.7 8.5999 9.9 8.2999C10.2 7.8999 10.5 7.7999 11 7.6999Z"
            fill={colors.icon}
        />
        <path
            d="M11.4998 0.799805C5.5998 0.799805 0.799805 5.5998 0.799805 11.4998C0.799805 17.3998 5.5998 22.2998 11.5998 22.2998C17.5998 22.2998 22.3998 17.4998 22.3998 11.4998C22.3998 5.4998 17.3998 0.799805 11.4998 0.799805ZM11.4998 20.7998C6.3998 20.7998 2.2998 16.6998 2.2998 11.5998C2.2998 6.4998 6.3998 2.3998 11.4998 2.3998C16.5998 2.3998 20.6998 6.4998 20.6998 11.5998C20.6998 16.6998 16.5998 20.7998 11.4998 20.7998Z"
            fill={colors.icon}
        />
    </svg>
);

export const BellIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.2002 19.1C19.6002 16.9 18.7002 14.2 18.7002 11.5V10.6C18.7002 7.4 16.3002 4.8 13.2002 4.4V2.5H11.7002V4.3C8.6002 4.7 6.2002 7.3 6.2002 10.5V11.4C6.2002 14.2 5.4002 16.8 3.7002 19L4.3002 20.2H8.7002C9.0002 21.9 10.6002 23.2 12.4002 23.2C14.2002 23.2 15.7002 21.9 16.1002 20.2H20.5002L21.2002 19.1ZM12.5002 21.8C11.5002 21.8 10.7002 21.2 10.4002 20.3H14.6002C14.3002 21.1 13.5002 21.8 12.5002 21.8ZM5.8002 18.8C7.1002 16.6 7.8002 14.1 7.8002 11.5V10.6C7.8002 8 9.9002 5.8 12.6002 5.8C15.3002 5.8 17.4002 7.9 17.4002 10.6V11.5C17.4002 14.1 18.1002 16.6 19.4002 18.8H5.8002Z"
            fill={colors.icon}
        />
    </svg>
);

export const BlueInfoIcon = () => (

    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
         fill={applicationMessageTypesColors.info}>
        <path
            d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>);

export const
    OrangeWarningIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
             fill={applicationMessageTypesColors.warning}>
            <path
                d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" />
        </svg>);


export const RedErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill={applicationMessageTypesColors.error}>
        <path
            d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>);
export const CommandsIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.2002 5.1001H3.7002V6.6001H21.2002V5.1001Z" fill={colors.icon} />
        <path d="M21.2002 8.1001H3.7002V9.6001H21.2002V8.1001Z" fill={colors.icon} />
        <path
            d="M13.8002 15.5001L12.7002 16.6001L14.9002 18.8001H16.0002L21.2002 13.6001L20.1002 12.6001L15.5002 17.2001L13.8002 15.5001Z"
            fill={colors.icon}
        />
        <path
            d="M3.7002 15.7002H7.1002C7.2002 15.2002 7.3002 14.7002 7.5002 14.2002H3.7002V15.7002Z"
            fill={colors.icon}
        />
        <path
            d="M3.7002 12.7002H8.2002C8.5002 12.2002 8.9002 11.6002 9.4002 11.2002H3.7002V12.7002Z"
            fill={colors.icon}
        />
        <path
            d="M21.1002 15.8L19.7002 17.2C19.7002 19.5 17.8002 21.4 15.5002 21.4C13.2002 21.4 11.3002 19.5 11.3002 17.2C11.3002 14.9 13.2002 13 15.5002 13C16.2002 13 16.8002 13.2 17.4002 13.5L18.5002 12.4C17.6002 11.9 16.6002 11.5 15.5002 11.5C12.3002 11.5 9.7002 14.1 9.7002 17.3C9.7002 20.5 12.3002 23.1 15.5002 23.1C18.7002 23.1 21.3002 20.5 21.3002 17.3C21.2002 16.7 21.2002 16.2 21.1002 15.8Z"
            fill={colors.icon}
        />
        <path d="M21.2002 2.1001H3.7002V3.6001H21.2002V2.1001Z" fill={colors.icon} />
    </svg>
);

export const SwitchIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.8002 3.6001L16.5002 4.1001V6.9001H10.5002V8.4001H17.3002L18.0002 7.7001V5.9001L22.2002 10.1001L18.0002 14.3001V12.2001V12.1001V11.7001H17.3002H17.0002H12.5002H8.5002V8.9001L7.2002 8.4001L1.2002 14.4001V15.4001L7.2002 21.4001L8.5002 20.9001V18.1001H14.5002V16.6001H7.9002H7.7002H7.0002V17.3001V17.6001V19.1001L2.8002 14.9001L7.0002 10.7001V12.5001L7.7002 13.2001H12.5002H16.5002V16.1001L17.8002 16.6001L23.8002 10.6001V9.6001L17.8002 3.6001Z"
            fill={colors.text_T1}
            transform="rotate(90 12.5 12.5)"
        />
    </svg>
);

export const SearchIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.4998 19.4999L16.5998 15.5999C17.5998 14.3999 18.0998 12.8999 18.0998 11.2999C18.0998 7.4999 14.9998 4.3999 11.1998 4.3999C7.3998 4.3999 4.2998 7.4999 4.2998 11.2999C4.2998 15.0999 7.3998 18.1999 11.1998 18.1999C12.7998 18.1999 14.2998 17.5999 15.4998 16.6999L19.3998 20.5999L20.4998 19.4999ZM11.1998 16.5999C8.1998 16.5999 5.7998 14.1999 5.7998 11.1999C5.7998 8.1999 8.1998 5.7999 11.1998 5.7999C14.1998 5.7999 16.5998 8.1999 16.5998 11.1999C16.5998 14.1999 14.1998 16.5999 11.1998 16.5999Z"
            fill={colors.icon}
        />
    </svg>
);

export const ProductCustomizationIcon = () => (
    <svg width="27" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.24 30.54">
        <path
            fill="#0a1825"
            strokeWidth="0px"
            d="m15.47,24.8l1.12,1.41h.01l-1.13-1.41Zm5.21,1.41h.02l1.12-1.41-1.14,1.41Z"
        />
        <polygon
            fill={colors.icon}
            strokeWidth="0px"
            points="23.1 28.74 23.1 30.54 12.65 30.54 10.75 26.25 9.37 26.25 7.47 30.54 0 30.54 .89 28.64 .93 28.56 8.54 11.29 10.18 12.02 2.82 28.74 6.3 28.74 8.19 24.45 11.91 24.45 11.91 24.46 11.93 24.45 13.82 28.74 23.1 28.74"
        />
        <polygon fill={colors.icon} strokeWidth="0px" points="8.68 22.51 11.42 22.51 10.05 19.64 8.68 22.51" />
        <path
            fill={colors.icon}
            strokeWidth="0px"
            d="m27.24,5.41V0h-1.8v3.61h-13.51V0h-1.8v5.41h3.07v2.97h-1.37v7.13l2.31,2.89h1.32v6.39h.01s1.13,1.42,1.13,1.42l2.04,2.54,2.04-2.54,1.14-1.41h0v-6.4h1.4l2.31-2.89v-7.13h-1.47v-2.97h3.17Zm-12.24,0h7.27v2.97h-7.27v-2.97Zm5.03,18.75l-1.38,1.74-.88-1.1,2.26-1.5v.86Zm0-3.02l-2.77,1.85v-1.29l2.77-1.84v1.28Zm-2.77-1.61v-1.13h1.71l-1.71,1.13Zm6.48-5.82h-6.77v1.8h6.26l-.87,1.09h-7.35l-.87-1.09h2.22v-1.8h-2.73v-3.53h10.11v3.53Z"
        />
    </svg>
);

export const UserDetailIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 1.5C6.4 1.5 1.5 6.4 1.5 12.5C1.5 18.6 6.4 23.5 12.5 23.5C18.6 23.5 23.5 18.6 23.5 12.5C23.5 6.4 18.6 1.5 12.5 1.5ZM8.8 21.2V17.3C8.8 15.2 10.5 13.5 12.6 13.5C14.7 13.5 16.4 15.2 16.4 17.3V21.2C15.2 21.7 14 22 12.6 22C11.2 22 9.9 21.7 8.8 21.2ZM10 9.6C10 8.2 11.1 7.1 12.5 7.1C13.9 7.1 15 8.2 15 9.6C15 11 13.9 12.1 12.5 12.1C11.1 12.1 10 10.9 10 9.6ZM17.8 20.4V17.3C17.8 15.3 16.7 13.6 15 12.7C15.9 12 16.5 10.8 16.5 9.6C16.5 7.4 14.7 5.6 12.5 5.6C10.3 5.6 8.5 7.4 8.5 9.6C8.5 10.9 9.1 12 10 12.7C8.3 13.6 7.2 15.3 7.2 17.3V20.4C4.7 18.7 3 15.8 3 12.5C3 7.3 7.3 3 12.5 3C17.7 3 22 7.3 22 12.5C22 15.8 20.3 18.7 17.8 20.4Z"
            fill={colors.icon}
        />
    </svg>
);

export const PermissionsIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.2998 17.5002C3.2998 14.6002 5.6998 12.3002 8.4998 12.3002C11.0998 12.3002 13.2998 10.2002 13.2998 7.5002C13.2998 4.8002 11.1998 2.7002 8.4998 2.7002C5.7998 2.7002 3.7998 4.9002 3.7998 7.5002C3.7998 9.1002 4.5998 10.5002 5.7998 11.3002C3.4998 12.4002 1.7998 14.7002 1.7998 17.4002V22.2002H2.5998H14.5998V20.7002H3.1998L3.2998 17.5002ZM5.2998 7.5002C5.2998 5.7002 6.7998 4.3002 8.4998 4.3002C10.1998 4.3002 11.6998 5.8002 11.6998 7.5002C11.6998 9.2002 10.1998 10.7002 8.4998 10.7002C6.7998 10.7002 5.2998 9.3002 5.2998 7.5002Z"
            fill={colors.icon}
        />
        <path
            d="M22.4994 15.6003V14.1003H21.1994C21.0994 13.5003 20.8994 12.9003 20.4994 12.4003L21.3994 11.5003L20.2994 10.4003L19.3994 11.3003C18.8994 10.9003 18.2994 10.7003 17.6994 10.6003V9.30029H16.1994V10.6003C15.5994 10.7003 14.9994 10.9003 14.4994 11.3003L13.5994 10.4003L12.4994 11.5003L13.3994 12.4003C12.9994 12.9003 12.7994 13.5003 12.6994 14.1003H11.3994V15.6003H12.6994C12.7994 16.2003 12.9994 16.8003 13.3994 17.3003L12.4994 18.2003L13.5994 19.3003L14.4994 18.4003C14.9994 18.8003 15.5994 19.0003 16.1994 19.1003V20.4003H17.6994V19.0003C18.2994 18.9003 18.8994 18.7003 19.3994 18.3003L20.2994 19.2003L21.3994 18.1003L20.4994 17.2003C20.8994 16.7003 21.0994 16.1003 21.1994 15.5003H22.4994V15.6003ZM15.0994 16.8003C14.5994 16.3003 14.2994 15.6003 14.2994 14.9003C14.2994 14.2003 14.5994 13.5003 15.0994 13.0003C15.5994 12.5003 16.2994 12.2003 16.9994 12.2003C17.6994 12.2003 18.3994 12.5003 18.8994 13.0003C19.3994 13.5003 19.6994 14.2003 19.6994 14.9003C19.6994 15.6003 19.3994 16.3003 18.8994 16.8003C18.3994 17.3003 17.6994 17.6003 16.9994 17.6003C16.2994 17.6003 15.5994 17.3003 15.0994 16.8003Z"
            fill={colors.icon}
        />
    </svg>
);

export const TransferArrowsIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.8002 3.6001L16.5002 4.1001V6.9001H10.5002V8.4001H17.3002L18.0002 7.7001V5.9001L22.2002 10.1001L18.0002 14.3001V12.2001V12.1001V11.7001H17.3002H17.0002H12.5002H8.5002V8.9001L7.2002 8.4001L1.2002 14.4001V15.4001L7.2002 21.4001L8.5002 20.9001V18.1001H14.5002V16.6001H7.9002H7.7002H7.0002V17.3001V17.6001V19.1001L2.8002 14.9001L7.0002 10.7001V12.5001L7.7002 13.2001H12.5002H16.5002V16.1001L17.8002 16.6001L23.8002 10.6001V9.6001L17.8002 3.6001Z"
            fill={colors.icon}
        />
    </svg>
);
